module.exports = __webpack_public_path__ + "img/sendIcon.5ac5ef84.svg";